import { ColumnSelectLabel } from "@common/facet";
import { BaseTableColumnsHelper } from "@common/util/table-columns/base-table-columns-helper";
import { Injectable } from "@angular/core";

@Injectable()
export class TasksInputsTableColumnsHelper extends BaseTableColumnsHelper {
    constructor() {
        const visibleColumns = {
            protocol: true,
            taskAlias: true,
            materials: true,
            inputs: true,
        };

        super(visibleColumns);
    }

    protected setupColumnSelectLabels(): void {
        this.columnSelectLabels = [
            new ColumnSelectLabel('protocol', 'Protocol'),
            new ColumnSelectLabel('taskAlias', 'Task'),
            new ColumnSelectLabel('materials', 'Animals/Samples'),
            new ColumnSelectLabel('inputs', 'Inputs'),
        ];
    }
}
